import HttpClient from "../../business/HttpClient";

const forbiddenWords = ["allah", "allupato", "allupata", "allupate", "allupati", "ammucchiata", "ammucchiate", "anal", "anale", "anali", "anoressico", "anoressica", "ano", "ani", "arrapato", "arrapata", "arrapati", "arrapate", "arrusa", "arruso", "assatanato", "asshole", "bagascia", "bagascie", "bagassa", "baggiana", "bagnarsi", "baldracca", "baldracche", "balengo", "balle", "balusa", "batacchio", "battona", "battone", "bastardo", "bastarda", "bastardi", "bastarde", "belino", "belin", "belino", "bega", "bitch", "blow job", "bocchinara", "bocchinare", "bocchinaro", "bocchinari", "bocchino", "bocchini", "bofilo", "boiata", "bordello", "bottana", "brinca", "brucapelo", "bucaiolo", "buco", "buchi", "bullo", "bulla", "bulli", "buliccio", "buona donna", "busone", "cacca", "cacche", "caccone", "caccati in mano e prenditi a schiaffi", "caciocappella", "cadavere", "cagare", "cago", "cagata", "cagate", "cagna", "cazzimma", "cazzino", "cazzo", "cazzola", "stocazzo", "cazzone", "cazzoni", "checca", "checche", "chiappa", "chiavo", "chiava", "chiavare", "chiavata", "ciccione", "cicciona", "ciccioni", "ciccione", "ciospo", "ciucciami", "ciuccia", "cock", "coglione", "coglioni", "cogliona", "cornuto", "cornuta", "cornute", "cornuti", "cozza", "cretino", "cretina", "cretini", "cretine", "cristo", "culattina", "culattone", "culattoni", "culo", "culone", "culona", "culi", "di merda", "diavolo", "dildo", "dio", "dirty", "ditalino", "ditalini", "duro", "eiaculazione", "escort", "fanculo", "fascista", "fascisti", "fava", "fica", "fiche", "figa", "figazza", "fighe", "figlio di buona donna", "figlio di puttana", "figone", "finocchio", "fottere", "fottona", "fottersi", "fottiti", "fotto", "fotti", "fracicone", "fregna", "frocio", "froci", "frocione", "froscio", "fuck", "fucker", "fucking", "gesu", "ges", "gnocca", "goldone", "grasso", "grassa", "grassi", "grasse", "grassone", "grassoni", "grilletto", "guanto", "guardone", "ignorante", "ingnoranti", "imbecille", "imbecilli", "immigrati", "immigrato", "incazzarsi", "incazzati", "incazzo", "incoglionirsi", "inculare", "inculo", "incula", "ingoio", "ingoia", "isis", "islam", "islamico", "l'arte bolognese", "leccaculo", "lecchino", "lesbica", "lesbiche", "lecca", "leccamelo", "leccamela", "leccami", "lecco", "leccaciuffo", "limonare", "lofare", "loffa", "loffare", "lumaca", "lurida", "lurido", "madonna", "maiala", "maiale", "maiali", "maialona", "maialoni", "manico", "mannaggia", "maometto", "matello", "merda", "merde", "merda secca", "meretrice", "merdaccia", "merdata", "merdina", "merdone", "merdoso", "mierda", "milf", "milfone", "milfona", "mignotta", "mignotte", "mignottone", "minchia", "minchione", "minnaÊ", "minne", "mona", "monta", "monto", "montare", "mussa", "nave scuola", "nerchia", "negro", "negra", "negri", "negre", "negrone", "negroni", "nuda", "nudi", "nudo", "nude", "olio di palma", "palma", "obesa", "obesi", "obese", "obeso", "orgia", "orgie", "padulo", "palle", "palloso", "passera", "passerina", "patacca", "patata", "patonza", "pecorina", "pedofilo", "pedofilia", "pelosa", "peloso", "pelose", "pelo", "peli", "pene", "peni", "pesce", "picio", "piglianculo", "piglia in culo", "pincare", "pipa", "pipi", "pip“", "pippa", "pippone", "pirla", "pisciare", "piscio", "pisci", "pisello", "piselli", "pistola", "pistolotto", "pomiciare", "pompa", "pompino", "pompinara", "poppe", "porca", "porca madonna", "porca miseria", "porca puttana", "porco", "porcona", "porcone", "porco zio", "potta", "puppami", "puta", "puttana", "puttanone", "puttane", "puttaniere", "preservativo", "profilattico", "profilattici", "preservativi", "prostituta", "prostitute", "quaglia", "randello", "recchione", "ricchione", "ricchioni", "rincoglionire", "rincoglionita", "rincoglionito", "rizzarsi", "rizza", "rizzacazzi", "rompiballe", "rottoinculo", "ruffiano", "rumenta", "salciccia", "satana", "sbattere", "sbattersi", "sbattimi", "sborra", "sboro", "sborare", "sborrata", "sborrone", "sbrodolata", "scopare", "scopiamo", "scopo", "scopi", "scopa", "scopata", "scorreggiare", "scorreggia", "scoreggio", "scorreggione", "scorreggiona", "sega", "seghe", "sesso", "sessuale", "sessuali", "sfigato", "sfigata", "sfigati", "sfigate", "slinguare", "slinguata", "slut", "smandrappata", "soccia", "socmel", "sorca", "sgualdrina", "sgualdrine", "spagnola", "sperma", "spermicida", "spompinare", "spompino", "spompini", "spompina", "sticchio", "stronzi", "stupido", "stupida", "stupidi", "stupide", "stronza", "stronze", "stronzata", "stronzate", "stronzo", "suca", "succhiami", "succhia", "sveltina", "sverginare", "svergare", "svergo", "tarzanello", "terrone", "terroni", "terrorista", "terroristi", "testa di cazzo", "testicolo", "testicoli", "tetta", "tette", "tettina", "tettine", "tettona", "tettone", "topa", "transessuale", "travone", "troia", "troie", "troione", "troiona", "trombare", "trombo", "tromba", "uccello", "vacca", "vaccaputtana", "vaccatroia", "vacche", "vaffanculo", "vagina", "vagine", "vangare", "verga", "vergine", "vergini", "viadone", "viadoni", "vibratore", "vibratori", "viados", "zinna", "zinne", "zio cantante", "zoccola", "zoccolone", "zoticone"];

const openModal = (modal) => {
    modal.classList.add('modal-visible');
    setTimeout(() => modal.classList.add('pop'), 100);
    document.body.classList.add('no-scroll');

    const closeButton = modal.querySelector('.umdf-modal__close');
    closeButton && closeButton.addEventListener('click', () => {
        modal.classList.remove('pop');
        setTimeout(() => modal.classList.remove('modal-visible'), 200);
        document.body.classList.remove('no-scroll');
    });
}

const closeModal = () => {
    const modal = document.querySelector('.umdf-modal.modal-visible');
    if (modal) modal.classList.remove('modal-visible');
    document.body.classList.remove('no-scroll');
}

const scrollToError = (wrapper) => {
    const element = wrapper.querySelector('.data-step-form__input.error');
    element && element.scrollIntoView();
}

const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

const forbiddenWordsValidation = (string) => {
    if (!string || !string.length) return true;
    string = string.trim();
    string = string.replace(/[^\w\s]|_/g, "");
    let words = string.split(" ");
    for (let word of words) {
        if (forbiddenWords.find((forbidden) => word.toLowerCase() === forbidden.toLowerCase())) return false;
    }
    return true;
}


const addForbiddenWordValidators = (inputName, pristine) => {
    const input = document.getElementById(inputName);
    pristine.addValidator(input, function (value) {
        return Utils.forbiddenWordsValidation(value);
    }, "Il testo contiene parole non consentite", 2, false);
}

const isMobileDevice = () => {
    return (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i));
}

const uploadAndValidateFile = (type, file) => {
    return new Promise((resolve, reject) => {
        HttpClient.doCall({
            method: 'POST',
            url: API_ENDPOINT + `/api/mulinobianco/1.0/web/mdf/validate-image/${type}`,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: file
        }).then(
            (data) => resolve(data.body),
            (error) => reject(error)
        );
    });
}

const showVideoLoader = () => {
    document.querySelector('#layerVideo')?.classList.remove('hidden');
    document.body.classList.add('no-scroll');
}

const hideVideoLoader = () => {
    document.querySelector('#layerVideo')?.classList.add('fade');
    document.body.classList.remove('no-scroll');
    setTimeout(() => {
        document.querySelector('#layerVideo')?.classList.add('hidden');
        document.querySelector('#layerVideo')?.classList.remove('fade');
    }, 300);
}


export var Utils = {
    openModal,
    closeModal,
    getBase64,
    forbiddenWordsValidation,
    addForbiddenWordValidators,
    isMobileDevice,
    uploadAndValidateFile,
    scrollToError,
    showVideoLoader,
    hideVideoLoader
};
